import React from 'react';

const CancellationPolicy = () => (
  <div>
    <p>This is a sample cancellation policy.</p>
  </div>
);

export default CancellationPolicy; 